var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Pipe } from '@angular/core';
import { OrderByPipe } from './order-by';
// tslint:disable use-pipe-transform-interface
var OrderByImpurePipe = (function (_super) {
    __extends(OrderByImpurePipe, _super);
    function OrderByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: 'orderByImpure', pure: false },] },
    ];
    /** @nocollapse */
    OrderByImpurePipe.ctorParameters = function () { return []; };
    return OrderByImpurePipe;
}(OrderByPipe));
export { OrderByImpurePipe };
//# sourceMappingURL=order-by-impure.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/order-by-impure.js
// module id = 228
// module chunks = 4